Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    COLORS = _STYLES$useStyles.COLORS,
    focused = _STYLES$useStyles.focused,
    input = _STYLES$useStyles.input,
    fontRegular = _STYLES$useStyles.fontRegular,
    boxShadows = _STYLES$useStyles.boxShadows;
  var container = Object.assign({}, input, {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: (0, _styles.getREM)(0.125),
    paddingRight: (0, _styles.getREM)(0.125)
  });
  if (bp.desktop) {
    container.paddingLeft = (0, _styles.getREM)(0.8125);
    container.paddingRight = (0, _styles.getREM)(0.8125);
  }
  var container_focused = Object.assign({}, focused);
  var buttonNativeContainer = Object.assign({}, boxShadows.button.ios, {
    backgroundColor: COLORS.white,
    borderRadius: (0, _styles.getREM)(1.875 / 2)
  });
  if (bp.desktop) {
    buttonNativeContainer.borderRadius = (0, _styles.getREM)(2.375 / 2);
  }
  var buttonTextStyle = Object.assign({}, fontRegular, {
    width: (0, _styles.getREM)(1.875),
    height: (0, _styles.getREM)(1.875),
    borderRadius: (0, _styles.getREM)(1.875 / 2),
    backgroundColor: COLORS.aubergine,
    color: COLORS.white,
    fontSize: (0, _styles.getREM)(1.5),
    lineHeight: (0, _styles.getREM)(2),
    padding: 0,
    margin: (0, _styles.getREM)(0.1875),
    overflow: 'hidden',
    textAlign: 'center'
  }, boxShadows.button.web, boxShadows.button.android);
  if (bp.desktop) {
    buttonTextStyle.width = (0, _styles.getREM)(2.375);
    buttonTextStyle.height = (0, _styles.getREM)(2.375);
    buttonTextStyle.lineHeight = (0, _styles.getREM)(2.5);
    buttonTextStyle.borderRadius = (0, _styles.getREM)(2.375 / 2);
  }
  var buttonTextStyle_pointerOver = Object.assign({}, boxShadows.button_pointerOver.web);
  var buttonTextStyle_disabled = Object.assign({}, _reactNative.Platform.select({
    web: {
      cursor: 'default'
    }
  }));
  var value = {
    color: input.color,
    fontFamily: input.fontFamily,
    fontSize: input.fontSize,
    lineHeight: input.lineHeight,
    borderWidth: 0,
    textAlign: 'center',
    padding: 0,
    backgroundColor: input.backgroundColor,
    minWidth: 0
  };
  if (_reactNative.Platform.OS === 'web') {
    value.outlineWidth = 0;
  }
  if (bp.desktop) {
    value.fontSize = _styles.STYLES.fontSize.m;
    value.lineHeight = _styles.STYLES.lineHeight.m;
  }
  var styles = _reactNative.StyleSheet.create({
    container: container,
    container_focused: container_focused,
    buttonNativeContainer: buttonNativeContainer,
    buttonTextStyle: buttonTextStyle,
    buttonTextStyle_pointerOver: buttonTextStyle_pointerOver,
    buttonTextStyle_disabled: buttonTextStyle_disabled,
    value: value
  });
  return {
    styles: styles
  };
};